import { render, staticRenderFns } from "./ContentDonut.vue?vue&type=template&id=e6006706&"
import script from "./ContentDonut.vue?vue&type=script&lang=js&"
export * from "./ContentDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports